import '../vendor/jquery.fileupload';
import '../vendor/jquery.cloudinary';
import '../vendor/attachinary';

if (window.__CLOUDINARY_CONFIG) {
  $.cloudinary.config(window.__CLOUDINARY_CONFIG);
}

const oldTemplateFunc = $.attachinary.Templating.template;
$.attachinary.Templating.template = function sanitizedTemplate(str, data) {
  const sanitized = JSON.parse(JSON.stringify(data)
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/\\"/g, '&#34;'),
  );

  return oldTemplateFunc.bind(this, str, sanitized)();
};

class DropzoneMessageManager {
  constructor($message, $dropbox) {
    this.$message = $message;
    this.$dropbox = $dropbox;
    const nonIEMessage = $message.find('[rel=dropbox-non-ie-message]');
    const IEMessage = I18n.t('js.shared.attachinary.dropbox_ie_message_html', { spanOpen: '<span class="color-blue">', spanClose: '</span>' });
    const firefoxMessage = I18n.t('js.shared.attachinary.dropbox_firefox_message_html', { spanOpen: '<span class="color-blue">', spanClose: '</span>' });

    if ($.browser.msie) {
      this.$message.html(IEMessage);
    } else if ($.browser.mozilla) {
      this._linkMessageClickToFileInput();
      this.$message.html(firefoxMessage);
    } else {
      nonIEMessage.show();
    }

    this.$message.prop('originalValue', this.$message.html());
  }

  set(text) {
    this.$message.html(text);
  }

  hideMessage() {
    this.$message.hide();
  }

  showMessage() {
    this.$message.show();
  }

  restore() {
    this.$message.html(this.$message.prop('originalValue'));
  }

  _linkMessageClickToFileInput() {
    this.$message.click(function (e) {
      if (e.currentTarget === this && e.target.nodeName !== 'INPUT') {
        $(this.control).click();
      }
    });

    this.$message.height(this.$dropbox.height());
  }
}

class AttachinaryDropzone {
  constructor($dropbox) {
    this.$dropbox = $dropbox;
    this.$container = $dropbox.parents('[data-upload-container]');
    this.$progressBar = this.$dropbox.find('[rel=dropbox-progress-bar]');
    this.$photoContainer = this.$dropbox.find('[rel=photo-container]');
    this.$attachinaryInput = this.$dropbox.find('input.attachinary-input');
    this.$smallPhotoWarning = this.$container.find('[data-small-photo-warning]');
    this.$smallPhotoError = this.$container.find('[data-small-photo-error]');
    this.$smallPhotoErrorClose = this.$smallPhotoError.find('[data-close-small-photo-error]');
    this.singleFileDropzone = $dropbox.hasClass('single-file');
    this.dropzoneMessage = new DropzoneMessageManager(this.$dropbox.find('label[rel=message]'), this.$dropbox);
    this.shouldDisableDragDrop = ($.browser.mozilla || $.browser.msie);
    this.showImageDimensionWarning = this.$dropbox.data('show-image-dimension-warning') !== undefined;
    this.eventNamespace = this.$dropbox.data('event-namespace');
    this.dropzoneHadFilesBeforeDragover = false;

    if (this.shouldDisableDragDrop) { this.$dropbox.find('[rel=dragdrop-disabled]').show(); }

    $.attachinary.config.template = this.$dropbox.find('script[type=\'text/template\']').html();
    $.attachinary.config.disableWith = null;

    this.bindEventHandlers(this.$attachinaryInput);

    if (this.$dropbox.hasClass('has-files')) {
      this.showPhotos();
      this.handleThumbnailReorder();
    }

    this.displayHasFilesMessage();

    this.bindDropzoneDragover();
    this.bindBodyDragover();
  }

  // When someone starts hovering over the body,
  // enlarge the dropzone so it's harder to miss
  bindBodyDragover() {
    $('body').on({
      dragenter: (e) => {
        this.enlargeDroppableArea();
        this.onDragOver(e);
        this.stopProp(e);
      },
      dragover: () => this.stopProp,
      dragexit: () => this.stopProp,
      drop: (e) => {
        this.checkForDisabledDragDrop();
        this.stopProp(e);
      },
    });
  }

  // Firefox doesn't do well with the drop event because
  // the input cannot be styled to be larger than it truly is.
  // That means if you drop anywhere outside the actual file input,
  // the upload will not work. To make that work would require somehow
  // forwarding the drop event and the correct e.dataTransfer to the
  // fileupload plugin itthis, which would require hacking its internals.
  checkForDisabledDragDrop() {
    if (this.shouldDisableDragDrop) {
      this.dropzoneMessage.set(I18n.t('js.shared.attachinary.no_drag_drop_message_html', {
        spanOpen: '<span class="color-blue">',
        spanClose: '</span>',
      }));
    }
  }

  stopProp(e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }

  bindDropzoneDragover() {
    this.$dropbox.on({
      dragenter: (e) => {
        this.onDragOver(e);
        return false;
      },
      dragleave: (e) => {
        this.$dropbox.removeClass('hover');
        this.restoreDropzoneSize();
        this.stopProp(e);
        return false;
      },
      drop: (e) => {
        this.restoreDropzoneSize();
        this.checkForDisabledDragDrop();
        this.stopProp(e);
        return false;
      },
    });
  }

  enlargeDroppableArea() {
    this.$attachinaryInput.width('10000px');
    this.$attachinaryInput.height('10000px');
    this.$attachinaryInput.css({ top: 0, left: 0, position: 'fixed' });
  }

  onDragOver(e) {
    if (this.shouldDisableDragDrop) { return; } // no drag in firefox

    // specific counts don't matter here, we just need to pass 1, or more than 1 into the translation
    this.dropzoneMessage.set(I18n.t('js.shared.attachinary.drop_your_photo_here', { count: this.singleFileDropzone ? 1 : 2 }));
    this.dropzoneHadFilesBeforeDragover = this.hasFiles();
    this.$dropbox.addClass('hover');

    this.stopProp(e);
  }

  restoreDropzoneSize() {
    this.dropzoneMessage.restore();

    if (this.dropzoneHadFilesBeforeDragover) { this.showPhotos(); }

    this.$dropbox.height('auto');
    this.$attachinaryInput.css({
      top: '', left: '', position: 'absolute', width: 'auto', height: '100%',
    });
  }

  showPhotos() {
    this.$photoContainer.show();
    this.$dropbox.addClass('has-files');
    this.attachinaryContainer().appendTo(this.$photoContainer);
  }

  hidePhotos() {
    this.$photoContainer.hide();
    this.$dropbox.removeClass('has-files');
  }

  parseThumbnailOrder() {
    if (!this.hasManyFiles()) { return true; }

    const photos = $(JSON.parse(this.photosInput().val()));

    const sortedPhotos = this.attachinaryContainerImages().map(function (index) {
      const photoId = $(this).data('public-id');
      const photo = photos.filter(function () { return this.public_id === photoId; })[0];

      return { position: index, public_id: photo.public_id };
    });

    const form = this.attachinaryContainerForm();

    $(sortedPhotos).each(function () {
      const input = $(`<input type='hidden' name='photo_order[${this.public_id}]'/>`).val(this.position);
      form.append(input);
    });

    return true;
  }

  attachinaryContainer() {
    return this.$dropbox.find('.attachinary_container');
  }

  attachinaryContainerImages() {
    return this.attachinaryContainer().find('img');
  }

  attachinaryContainerForm() {
    return this.attachinaryContainer().parents('form');
  }

  photosInput() {
    return this.$dropbox.find('input[type=hidden]');
  }

  handleThumbnailReorder() {
    if (this.singleFileDropzone) { return; } // don't operate on single-file dropzones
    this.attachinaryContainer().find('[data-thumb-container]').sortable();
  }

  checkFileDimensions() {
    const self = this;
    const minimumDimension = 620;
    let smallPhoto = false;

    this.attachinaryContainerImages().each(function () {
      const img = $(this);

      if (self.imageTooSmall(img, minimumDimension)) {
        smallPhoto = true;
        img.parent('li').addClass('error');
        img.parent('li').append('<p class=\'overlay small-image-warning\'><i class=\'ph ph-warning\'><\/i></p>');
      }
    });

    this.$smallPhotoWarning.toggle(smallPhoto);
  }

  validateMinimumDimensions() {
    const that = this;
    const minimumDimension = 200;
    const $img = this.attachinaryContainerImages().last();

    if (this.imageTooSmall($img, minimumDimension)) {
      $img.parent('li').find('[data-remove]').trigger('click');
      this.$smallPhotoError.show();

      this.$smallPhotoErrorClose.on('click.imageError', () => {
        that.$smallPhotoError.hide();
      });
    } else {
      this.$smallPhotoError.hide();
    }
  }

  imageTooSmall($img, minimumDimension) {
    const width = $img.data('orig-width');
    const height = $img.data('orig-height');

    return (parseInt(width, 10) < minimumDimension) || (parseInt(height, 10) < minimumDimension);
  }

  displayHasFilesMessage() {
    if (!this.singleFileDropzone) { return; } // this is only for single file dropzones

    if (this.hasFiles()) {
      this.dropzoneMessage.hideMessage();
    } else {
      this.dropzoneMessage.showMessage();
    }
  }

  hasFiles() {
    return this.attachinaryContainerImages().length > 0;
  }

  hasManyFiles() {
    return this.attachinaryContainerImages().length > 1;
  }

  bindEventHandlers(selector) {
    const $attachinary = selector.attachinary({ sequentialUploads: false });
    this.attachinary = $attachinary.data('attachinary-bond');

    selector.bind('fileremoved', () => this.onFileRemoved());
    selector.bind('fileuploaddragover', e => this.onDragOver(e));
    selector.bind('fileuploadadd', () => this.showPhotos());
    selector.bind('fileuploaddone', e => this.onFileUploadDone(e));
    selector.bind('fileuploadstop', () => this.onFileUploadsAllDone());
    selector.bind('fileuploadprogressall', (e, data) => this.onFileUploadProgress(e, data));
    selector.parents('form').bind('submit', () => {
      this.parseThumbnailOrder();
      return true;
    });
  }

  onFileUploadsAllDone() {
    this.setProgressBarPercent(100);
    setTimeout(() => this.hideProgressBar(), 250);
  }

  onFileUploadDone() {
    if (this.showImageDimensionWarning) {
      this.validateMinimumDimensions();
      this.checkFileDimensions();
    }
    this.handleThumbnailReorder();
    this.displayHasFilesMessage();
  }

  onFileRemoved() {
    this.checkFileDimensions();
    this.displayHasFilesMessage();
    this.handleThumbnailReorder();

    if (!this.hasFiles()) { this.hidePhotos(); }
  }

  onFileUploadProgress(e, data) {
    // There is a bit of delay between the last fileuploadprogress event, and
    // the time when all file uploads finish (in fileuploadstop). To avoid
    // the progress bar prematurely disappearing, we will move it to the 90%
    // mark here, and finish the last bit inside the event when all uploads complete.
    const almostFullPercent = 90;

    this.showPhotos();

    const ratio = this.progressRatio(data);

    this.setProgressBarPercent(almostFullPercent * ratio);
  }

  setProgressBarPercent(percent) {
    this.$progressBar.html(`<div class='dropbox-progress-bar' style='width:${percent}%'><span class='ph ph-spinner-gap ph-animation-spin'></span> ${I18n.t('js.shared.attachinary.uploading')}</div>`);
    this.$progressBar.show();
  }

  hideProgressBar() {
    this.$progressBar.fadeOut();
  }

  progressRatio(data) {
    return parseFloat(data.loaded) / parseFloat(data.total);
  }
}

$(() => {
  if ($('.dropbox').length > 0) {
    $('.dropbox').each((index, el) => {
      // eslint-disable-next-line
      new AttachinaryDropzone($(el));
    });
  }
});

export default AttachinaryDropzone;
